import axios from 'axios';
import { json } from "react-router-dom";
import axiosInstance from 'src/hooks/axios-interceptor';




export const CreateOrg = (body) => {
  
  return axiosInstance.post(`axiosInstance}/createNewOrganization`, body);
};

export const getUser = (orgId) => {
  
  return axios.get(`axiosInstance}/organization/${orgId}`);
 
};

export const getAllOrgs = () => {
  
  return axiosInstance.get(`axiosInstance}/getAllOrganizations`);
 
};
export const updateUser = (body) => {

  // body.organization = { id: 1 };
  return axiosInstance
    .put(`axiosInstance}/user/1`, body)
    .then((response) => {
    
      return response.data.response[0];
    })
    .catch((error) => {
      var response = catchAxiosError(error);
      return response;
    });
};

export const Createuser = (Url,body,token) => {
  
  return axiosInstance.post(`axiosInstance}/createNewUser`, body).then((response) => {
    return response.data.response[0];
  })
  .catch((error) => {
    var response = catchAxiosError(error);
    return response;
  });
};


export const deleteUser = (orgId,token) => {
  return axiosInstance.delete(`/api/organization/${orgId}`).then((response) => {
    return response.data.response[0];
  })
  .catch((error) => {
    var response = catchAxiosError(error);
    return response;
  });
};


export const UpdateOrg = (body) => {
  // body.organization = { id: 1 };
  return axiosInstance
    .put(`axiosInstance}/organization/1`, body)
    .then((response) => {
      return response.data.response[0];
    })
    .catch((error) => {
      var response = catchAxiosError(error);
      return response;
    });
};



const catchAxiosError = (error) => {
  if (!error.response) {
    // network error
    return json(
      {},
      {
        status: 404,
      }
    );
  } else {
    const message = error.message;
    return { errors:[message]}
  }
};
